// @ts-nocheck
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import {
    chain,
    LoadData as baseLoadData,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/LoadDataIfNeeded";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadData = createChainHandler("LoadData", chain, props => {
    const state = props.getState();
    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }
    if (props.parameter.cartId) {
        const cartState = getCartState(state, props.parameter.cartId);
        if (!cartState.value && !cartState.isLoading) {
            const promotionsState = getPromotionsDataView(state, props.parameter.cartId);
            const shouldLoadPromotions = !promotionsState.value && !promotionsState.isLoading;
            props.dispatch(loadCart({ cartId: props.parameter.cartId, getPromotions: shouldLoadPromotions }));
        }
    } else {
        const currentCartState = getCurrentCartState(state);
        /* Store Custom Code - Start */
        const partRunnerCheck =
            currentCartState?.value?.properties.partrunnerapplies &&
            currentCartState?.value?.properties.partrunnerapplies.toLowerCase() === "true" &&
            currentCartState?.value?.properties.partrunnerloaded &&
            currentCartState?.value?.properties.partrunnerloaded.toLowerCase() === "false";
        /* Store Custom Code - End */
        if (
            (!currentCartState.value ||
                partRunnerCheck || // Store Custom Code
                (props.parameter.cartLinesShouldBeExpanded &&
                    ((currentCartState.value.lineCount && !currentCartState.value.cartLines?.length) ||
                        !currentCartState.value.carriers))) &&
            !currentCartState.isLoading
        ) {
            const currentPromotionsState = getCurrentPromotionsDataView(state);
            const shouldLoadPromotions = !currentPromotionsState.value && !currentPromotionsState.isLoading;
            props.dispatch(loadCurrentCart({ getPromotions: shouldLoadPromotions }));
        }
    }
});

replaceInChain(chain, baseLoadData, LoadData);
